"use client";

type StripePortalSessionResponse = {
  portal_session_id: string;
  url: string;
};

type StripeCreditCheckoutSessionResponse = {
  checkout_session_id: string;
  url: string;
  amount_cents: number;
};

export const createStripePortalSession = async (returnUrl?: string): Promise<StripePortalSessionResponse> => {
  const res = await fetch("/api/billing/portal-session", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      return_url: returnUrl,
    }),
  });

  if (!res.ok) {
    throw new Error("Failed to create billing portal session.");
  }

  return (await res.json()) as StripePortalSessionResponse;
};

export const createCreditCheckoutSession = async (params: {
  amountMicro: string | number;
  successUrl?: string;
  cancelUrl?: string;
}): Promise<StripeCreditCheckoutSessionResponse> => {
  const res = await fetch("/api/billing/checkout-session", {
    method: "POST",
    credentials: "include",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      amount_micro: Number(params.amountMicro),
      success_url: params.successUrl,
      cancel_url: params.cancelUrl,
    }),
  });

  if (!res.ok) {
    throw new Error("Failed to create credit checkout session.");
  }

  return (await res.json()) as StripeCreditCheckoutSessionResponse;
};
